/**
 * Trigger: tr_account_transfers_insert
 * Purpose: Update account balances when an account transfer is inserted
 * Table: account_transfers
 * Event: AFTER INSERT
 */
export const TR_ACCOUNT_TRANSFERS_INSERT = `
CREATE TRIGGER tr_account_transfers_insert
AFTER INSERT ON account_transfers FOR EACH ROW
BEGIN
  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_out_id, new.currency_id, new.transfer_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_out_id, new.transfer_date);

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_in_id, new.currency_id, new.transfer_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_in_id, new.transfer_date);

  UPDATE account_balances
  SET transfers_amount = transfers_amount - new.amount
  WHERE account_id = new.account_out_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount - new.amount
  WHERE account_id = new.account_out_id
    AND currency_id = new.currency_id
    AND balance_date = new.transfer_date;

  UPDATE account_balances
  SET transfers_amount = transfers_amount + new.amount
  WHERE account_id = new.account_in_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount + new.amount
  WHERE account_id = new.account_in_id
    AND currency_id = new.currency_id
    AND balance_date = new.transfer_date;
END;
`;
